import {
  API_ENDPOINT,
  useClientApiV1GamesResultsResultIdUpdateMutation,
} from '../../resources/@types/accountSchema';

interface UseClientV1GamesResultsResultIdMutation {
  resultId: number;
  options?: Parameters<typeof useClientApiV1GamesResultsResultIdUpdateMutation>[0]['options'];
}

export function useGamesResultsResultIdUpdateMutation({
  resultId,
  options,
}: UseClientV1GamesResultsResultIdMutation) {
  return useClientApiV1GamesResultsResultIdUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_GAMES_RESULTS_RESULTID(resultId), // TODO: 변경이 필요할지도
    options,
  });
}
